import { ReactElement } from 'react'
import { Tooltip } from '@mui/material'
import { HelperWrapper } from 'src/components/helper-wrapper'

interface IProps {
  approvedConnection: boolean | null
  children: ReactElement
  title?: string
}

export const AccountConnectionWrapper = ({ approvedConnection, title, children }: IProps) => {
  const statusText =
    typeof approvedConnection === 'object' ? (
      <HelperWrapper t="inactive-status-text" />
    ) : approvedConnection ? (
      <HelperWrapper t="active-status-text" />
    ) : (
      <HelperWrapper t="pending-status-text" />
    )

  return (
    <Tooltip
      title={
        title ? (
          <div>
            <strong>{title}</strong>
            <br />
            <span>{statusText}</span>
          </div>
        ) : (
          <span>{statusText}</span>
        )
      }
    >
      <div>{children}</div>
    </Tooltip>
  )
}
